import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import awesome from "../../images/awesome.png";

export default function Thankyou() {
  return (
    <Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <Stack
          alignItems="center"
          sx={{
            py: 2,
            width: "100%",
            textAlign: "center",
            maxWidth: 800,
            margin: "auto"
          }}
        >
          <img src={awesome} alt="awesome" />
          <Typography
            id="modal-modal-description"
            sx={{ mt: 2, fontWeight: 500, mb: 8 }}
          >
            You have successfully purchased the service.
          </Typography>
        </Stack>
      </Box>
      <Box
        sx={{
          height: 84,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          width: "100%",
          color: "black"
        }}
      >
        <Typography variant="h4">Connect With Us</Typography>
        <Stack direction="row" spacing={2}>
          <FacebookIcon color="inherit" />
          <InstagramIcon color="inherit" />
          <YouTubeIcon color="inherit" />
          <LinkedInIcon color="inherit" />
        </Stack>
      </Box>
    </Box>
  );
}
